import { useState } from "react";
import BaseButton from "../../../components/ui/BaseButton";
import BaseModal from "../../../components/ui/BaseModal";
import BaseTextField from "../../../components/ui/BaseTextField";
import { useMutation } from "@tanstack/react-query";
import { createTalentPool, updateTalentPool } from "../../../services/api/talentPool";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/toast/toastSlice";

const AddEditTalentPoolModal = ({
  isAddEditTalentPoolModalOpen,
  setIsAddEditTalentPoolModalOpen,
  refetchTalentPool,
  isEdit=false,
  talentPoolData={}
}) => {
  const dispatch = useDispatch();
  const {
    isPending: isCreateTalentPoolApiLoading,
    mutateAsync: createTalentPoolMutation,
  } = useMutation({
    mutationFn: createTalentPool,
    enabled: false,
  });

  const { mutateAsync: updateTalentPoolMutation, isPending: isUpdateLoading } =
    useMutation({
      mutationFn: updateTalentPool,
    });

  const [talentPoolName, setTalentPoolName] = useState(talentPoolData?.name ?? "");

  const handleCreateTalentPool = async () => {
    try {
      const newTalentPool = await createTalentPool({ name: talentPoolName });
      setTalentPoolName("");
      refetchTalentPool();
      setIsAddEditTalentPoolModalOpen(false);
    } catch (error) {
      dispatch(
        showToast({
          message: error.response.data.message,
          type: "error",
        })
      );
    }
  };
const handleUpdateTalentPool = async () => {
  try {
    await updateTalentPoolMutation({
      id: talentPoolData?.id,
      payload: talentPoolName,
    });

    setTalentPoolName("");
    refetchTalentPool?.();
    setIsAddEditTalentPoolModalOpen(false);
  } catch (error) {
    dispatch(
      showToast({
        message:
          error?.response?.data?.message || "Failed to update talent pool",
        type: "error",
      })
    );
  }
};

  return (
    <BaseModal
      className="-top-[600px] overflow-auto"
      open={isAddEditTalentPoolModalOpen}
      close={setIsAddEditTalentPoolModalOpen}
    >
      <div className="py-4 px-6 w-[600px] ">
        <h6 className="text-dark font-normal border-b pb-1">
          {isEdit ? "Update Talent Pool" : " Add New Talent Pool"}
        </h6>

        <div className="mb-2 mt-3">
          <BaseTextField
            isDefaultField={false}
            label="Talent Pool Name"
            labelShrink={false}
            optional={false}
            value={talentPoolName}
            onChange={(e) => {
              setTalentPoolName(e.target.value);
            }}
          />
        </div>
      </div>
      <div
        className="d-flex content-center  bg-white py-6 "
        style={{
          boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.07)",
        }}
      >
        <BaseButton
          className="px-[28px] py-[5px] bg-light text-primary hover:!text-primary"
          variant="outlined"
          color="primary"
          style={{
            marginRight: "16px",
          }}
          onClick={() => {
            setIsAddEditTalentPoolModalOpen(false);
          }}
        >
          Cancel
        </BaseButton>

        <BaseButton
          isLoading={isCreateTalentPoolApiLoading}
          loaderSize={24}
          loaderColor="primary"
          className="px-[12px] py-[5px] min-w-32"
          color="primary"
          disabled={talentPoolName?.length ? false : true}
          onClick={isEdit? handleUpdateTalentPool: handleCreateTalentPool}
        >
          {isEdit ? "Update" : "Save"}
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export default AddEditTalentPoolModal;
